import { render, staticRenderFns } from "./Edi.vue?vue&type=template&id=61599b93&scoped=true&"
import script from "./Edi.vue?vue&type=script&lang=js&"
export * from "./Edi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61599b93",
  null
  
)

export default component.exports